"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Gabe Kelley, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1561))
 * @trackcomponent
 * @lastsynced 2025-04-16T17:02:15.646Z
 * @optimized using svgo:^3.0.2
 */
export const EstimatedDeliveryDate = createSVGIcon(
  <>
    <path
      d="M20.4 22.8a2.4 2.4 0 0 0 2.4-2.4V6a2.4 2.4 0 0 0-2.4-2.4H3.6A2.4 2.4 0 0 0 1.2 6v14.4a2.4 2.4 0 0 0 2.4 2.4M6 1.2v2.4M18 1.2v2.4M1.2 9.6h21.6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m7.8 19.8 3 3 6-6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "EstimatedDeliveryDate",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
